module.exports = __webpack_public_path__ + "img/pg.1382d23e.svg";